const windowObject = () => {
    return typeof window !== 'undefined' ? window : null;
}

const createDataLayer = (project, pageCategory, pageSubCategory, pageName) => {
    return {
        pageCategory,
        pageSubCategory,
        pageName: `${pageName} ${project?.__influencerName}`,
    }
}

const pushDataLayerToWindow = (dataLayer) => {
    const w = windowObject();

    if (w) {
        if (Array.isArray(w.dataLayer)) {
            w.dataLayer.push(dataLayer);
        }
        else {
            w.dataLayer = [dataLayer];
        }
    }
}

const addGTMDataLayerToWindow = (project, pageCategory, pageSubCategory, pageName) => {

    const dataLayer = createDataLayer(project, pageCategory, pageSubCategory, pageName);
    pushDataLayerToWindow(dataLayer);
}

const addGTMEventToWindow = (project, event, data) => {

    const dataLayer = {
        ...{ event },
        ...data
    }
    pushDataLayerToWindow(dataLayer);
}

export { addGTMDataLayerToWindow, addGTMEventToWindow, pushDataLayerToWindow }
